import { getMySessionListLoader } from "@/features/my-session"
import { isInApp } from "@/utils/in-app-checker"
import { signinInSign } from "@/utils/signin-insign"
import { defer } from "react-router-dom"

export const mySessionLoader = async () => {
  if (isInApp()) {
    await signinInSign()
    await getMySessionListLoader()
    return defer({})
  }

  throw new Response("Not Found", { status: 404 })
}
